var _style, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStep03(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 318.18 295",
    style: {
      enableBackground: "new 0 0 318.18 295"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_00000078044888921308430260000007310358745086445463_);}\n\t.st2{fill:url(#SVGID_00000013157378105754374550000010301851882594636221_);}\n\t.st3{fill:url(#SVGID_00000014622898951344151320000001849112126856606638_);}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -1660.7795,
    y1: -1515.4387,
    x2: 298.3244,
    y2: 304.1301
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0151,
    style: {
      stopColor: "#4471B7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8052A1"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M273.06,90.82h-17.64c-5.66-34.7-17.53-59.2-18.3-60.77c-0.02-0.05-0.06-0.08-0.08-0.13 c-0.1-0.19-0.22-0.37-0.35-0.54c-0.06-0.07-0.12-0.14-0.19-0.21c-0.13-0.14-0.26-0.26-0.41-0.38c-0.07-0.06-0.14-0.12-0.22-0.17 c-0.16-0.11-0.34-0.21-0.52-0.3c-0.07-0.03-0.14-0.07-0.21-0.1c-0.26-0.1-0.53-0.19-0.82-0.23c-0.29-0.05-0.57-0.05-0.85-0.03 c-0.07,0.01-0.14,0.02-0.22,0.03c-0.2,0.03-0.4,0.06-0.59,0.12c-0.09,0.03-0.18,0.06-0.27,0.1c-0.17,0.06-0.33,0.14-0.48,0.23 c-0.09,0.05-0.18,0.1-0.27,0.16c-0.16,0.11-0.31,0.23-0.46,0.37c-0.05,0.04-0.11,0.08-0.15,0.12c-1.22,1.25-27.9,29.06-45.04,71.81 c-16.25-49.53-48.07-82.75-49.66-84.39c-0.85-0.88-2.08-1.29-3.29-1.1c-1.21,0.19-2.25,0.96-2.8,2.06 c-0.86,1.75-15.57,32.12-20,73.34H45.58c-8.7,0-15.78,7.08-15.78,15.78v164.04c0,2.08,1.69,3.77,3.77,3.77h50.3h201.2 c0.24,0,0.47-0.03,0.7-0.07c0.08-0.01,0.15-0.04,0.23-0.06c0.15-0.04,0.29-0.08,0.43-0.13c0.08-0.03,0.16-0.07,0.24-0.11 c0.13-0.06,0.25-0.13,0.38-0.2c0.07-0.04,0.14-0.09,0.21-0.14c0.13-0.09,0.25-0.19,0.36-0.3c0.05-0.05,0.1-0.09,0.15-0.13 c0.16-0.16,0.3-0.33,0.43-0.52c0.01-0.01,0.01-0.02,0.02-0.03c0.12-0.18,0.22-0.37,0.31-0.56c0.03-0.07,0.05-0.15,0.08-0.23 c0.04-0.1,0.08-0.2,0.11-0.3c0.01-0.04,0.01-0.08,0.02-0.13c0.02-0.08,0.03-0.17,0.05-0.26c0.03-0.16,0.04-0.31,0.05-0.47 c0-0.05,0.01-0.09,0.01-0.14V106.6C288.84,97.9,281.76,90.82,273.06,90.82z M155.79,243.64c-7.49-8.18-14.73-21.56-21.02-38.27 l23.21-31.91l31.89,23.19c-0.9,19.4-4.07,35.4-9.36,45.3C172.15,242.09,163.89,242.65,155.79,243.64z M190.12,187.52l-30.76-22.37 c-0.81-0.59-1.82-0.83-2.81-0.68c-0.99,0.16-1.87,0.7-2.46,1.51l-22.38,30.77c-1.32-3.93-2.58-8-3.78-12.21l26.12-35.92 l35.91,26.12C190.11,179.11,190.17,183.37,190.12,187.52z M155.44,140.3c-1.69-1.23-4.05-0.85-5.27,0.83l-24.77,34.05 c-1.09-4.29-2.11-8.7-3.07-13.18l27.8-38.22l38.22,27.8c0.47,4.56,0.85,9.06,1.13,13.48L155.44,140.3z M118.71,142.43 c-0.25-1.59-0.47-3.17-0.68-4.75l28.18-38.75l38.75,28.19c0.29,1.56,0.57,3.14,0.82,4.72c0.5,3.19,0.96,6.37,1.38,9.53 l-35.64-25.92c-0.81-0.59-1.82-0.83-2.81-0.68c-0.99,0.16-1.87,0.7-2.46,1.51l-25.92,35.63 C119.76,148.79,119.21,145.63,118.71,142.43z M182.5,116L147.6,90.62c-0.81-0.59-1.82-0.83-2.81-0.68 c-0.99,0.16-1.87,0.7-2.46,1.51l-25.38,34.89c-0.37-5.75-0.46-11.42-0.32-16.96l25.66-35.28l35.29,25.67 C179.42,105,181.07,110.42,182.5,116z M194.91,142.47c6.48-30.09,19.57-55.1,28.53-69.71l-26.76,169.47 c-2.6-0.13-5.2-0.22-7.82-0.27C197.91,221.38,200.18,184.15,194.91,142.47z M230.89,73.95c4.46,18.48,9.81,50.73,4.35,85.31 c-5.68,35.95-15.89,68.44-26.29,83.93c-1.57-0.16-3.14-0.32-4.72-0.45L230.89,73.95z M242.69,160.44c8.16-51.68-6.49-97-9-104.24 l1.7-10.73c7.64,20.28,20.53,63.5,13.26,109.54c-5.67,35.93-16.31,69.13-28.64,89.58c-0.92-0.14-1.85-0.26-2.77-0.39 C227.59,226.8,237.13,195.63,242.69,160.44z M256.09,156.19c1.07-6.8,1.73-13.51,2.05-20.1h23.15v128.14 c-15.81-8.39-33.96-14.55-53.36-18.26C240.11,224.58,250.5,191.59,256.09,156.19z M273.06,98.36c4.54,0,8.24,3.69,8.24,8.24v21.94 h-22.93c0.11-10.55-0.61-20.69-1.84-30.18H273.06z M227.94,44.27l-1.7,10.75c-3.71,4.91-22.8,31.27-34.25,68.73 c-0.72-3.66-1.54-7.27-2.46-10.8C200.36,81.73,217.65,57.15,227.94,44.27z M134.7,26c7.58,8.82,24.99,30.86,37.8,60.74 l-28.82-20.96c-1.69-1.23-4.04-0.85-5.27,0.83l-20.96,28.82C120.44,63.06,130.21,36.73,134.7,26z M45.58,98.36h63.97 c-0.71,9.63-0.81,19.75-0.04,30.18H37.34V106.6C37.34,102.06,41.04,98.36,45.58,98.36z M37.34,136.09h72.89 c0.29,2.5,0.62,5,1.02,7.52c0.97,6.14,2.08,12.17,3.31,18.08c0.01,0.06,0.03,0.13,0.04,0.19c1.62,7.76,3.46,15.28,5.47,22.47 c0.04,0.29,0.13,0.58,0.24,0.85c2.03,7.18,4.23,14.02,6.58,20.44c0.07,0.29,0.17,0.58,0.31,0.85c5.9,15.97,12.69,29.26,19.8,38.42 c-23.66,3.85-45.66,11.31-64.12,21.96H37.34V136.09z M99.32,266.86c24.65-11.3,54.31-17.42,85.15-17.42s60.5,6.12,85.15,17.42 H99.32z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000062881379942843557060000015738519776062811539_",
    gradientUnits: "userSpaceOnUse",
    x1: -1679.576,
    y1: -1495.1954,
    x2: 279.5228,
    y2: 324.3687
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0151,
    style: {
      stopColor: "#4471B7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8052A1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000062881379942843557060000015738519776062811539_)"
    },
    d: "M52.43,123.51c2.08,0,3.77-1.69,3.77-3.77 v-12.57c0-2.08-1.69-3.77-3.77-3.77s-3.77,1.69-3.77,3.77v12.57C48.66,121.82,50.35,123.51,52.43,123.51z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000052074505725359989870000006545211540202296979_",
    gradientUnits: "userSpaceOnUse",
    x1: -1670.8466,
    y1: -1504.6064,
    x2: 288.2602,
    y2: 314.9651
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0151,
    style: {
      stopColor: "#4471B7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8052A1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000052074505725359989870000006545211540202296979_)"
    },
    d: "M71.3,123.51c2.08,0,3.77-1.69,3.77-3.77 v-12.57c0-2.08-1.69-3.77-3.77-3.77c-2.08,0-3.77,1.69-3.77,3.77v12.57C67.52,121.82,69.21,123.51,71.3,123.51z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000056421048619745147470000015213131887178544295_",
    gradientUnits: "userSpaceOnUse",
    x1: -1662.1113,
    y1: -1514.012,
    x2: 296.9955,
    y2: 305.5597
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0151,
    style: {
      stopColor: "#4471B7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8052A1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000056421048619745147470000015213131887178544295_)"
    },
    d: "M90.16,123.51c2.08,0,3.77-1.69,3.77-3.77 v-12.57c0-2.08-1.69-3.77-3.77-3.77c-2.08,0-3.77,1.69-3.77,3.77v12.57C86.38,121.82,88.07,123.51,90.16,123.51z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep03);
export default __webpack_public_path__ + "static/media/step_03.ccd7980c6807b6b0e651d3dc70a91237.svg";
export { ForwardRef as ReactComponent };